export default __webpack_public_path__ + "static/media/slider04.081d1e40.png";